import Vue from 'vue'
import Vuex from 'vuex'

import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

import * as appdef from '../appdef'
import * as storage from '../utils/storage'

Vue.use(Vuex)

const state = {
    tasks: [],
    name: '',
    email: '',
    identity: '',
    flowList: [],
    agvUUID: '',
    userList: [],
    favorites: storage.restore(appdef.KEY_STORAGE_FAVO) || [],
    pushRegistered: storage.restore(appdef.KEY_STORAGE_PUSHDEVICE) || false,
    messages: storage.restore(appdef.KEY_STORAGE_PUSHMESSAGE) || [],
    locale: 'tw'
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,

    strict: process.env.NODE_ENV !== "production"   // 不要在生产环境下启用严格模式
})



// WEBPACK FOOTER //
// ./src/store/index.js